import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Nav from 'react-bootstrap/Nav';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import T from 'i18n';
import { withoutTrailingSlash } from 'utils/path';
import { faColumns } from '@fortawesome/free-solid-svg-icons';

export default ({ history, className }) => {
  return (
    <div className={className}>
      <OverlayTrigger
        placement="left"
        delay={{ show: 1000, hide: 400 }}
        overlay={
          <Popover>
            <Popover.Content>{T.translate('case.rejoinPresentationToNewTab')}</Popover.Content>
          </Popover>
        }
      >
        <Nav.Link
          className="d-inline-flex"
          onClick={() => {
            const path = withoutTrailingSlash(history.location.pathname);
            history.push(path.replace('/conference', ''));
          }}
        >
          <FontAwesomeIcon icon={faColumns} />
        </Nav.Link>
      </OverlayTrigger>
    </div>
  );
};
